module.exports = __webpack_public_path__ + "static/media/trash_orange.36471677.svg";